@use '../../scss/utility';
@use 'grey-box-vars';

:host {
  @include grey-box-vars.wb-grey-box-vars;

  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  background-color: var(--grey-box-background-color);
  box-shadow: inset 0 0 0 var(--grey-box-border-weight) var(--grey-box-border-color);
  transition: box-shadow 0.3s var(--wb-fade);
}

:host([size='s']) {
  @include grey-box-vars.wb-grey-box-s-vars;
}

:host([size='m']) {
  @include grey-box-vars.wb-grey-box-m-vars;
}

:host([size='l']) {
  @include grey-box-vars.wb-grey-box-l-vars;
}

.caret-icon {
  position: relative;
  inset-inline-end: var(--grey-box-padding-inline-end);
  box-sizing: content-box;
}

:host([success]),
:host([error]) {
  --caret-icon-inset-inline-end: 0;
}

.status-icon {
  margin-block: 0;
  margin-inline: var(--grey-box-status-padding) calc(var(--grey-box-padding-inline-end) + var(--grey-box-status-padding));
  flex-shrink: 0;
}

:host(:focus-within) {
  @include grey-box-vars.wb-grey-box-focus-vars;
}

:host([active], [autofocus]) {
  @include grey-box-vars.wb-grey-box-active-vars;
}

:host([open]) {
  @include grey-box-vars.wb-grey-box-active-vars;
  .caret-icon {
    transform: rotateZ(180deg);
  }
}

:host([error]:not([active], [autofocus])) {
  @include grey-box-vars.wb-grey-box-error;
}

:host([success]:not([active], [autofocus])) {
  @include grey-box-vars.wb-grey-box-success;
}

:host(:not([disabled], [readonly], [active], [autofocus], [open]):hover) {
  @include grey-box-vars.wb-grey-box-hover-vars;
}

:host([readonly]) {
  @include grey-box-vars.wb-grey-box-readonly;
}

:host([disabled]) {
  cursor: not-allowed;
  opacity: var(--grey-box-opacity-disabled);

  input,
  textarea,
  label {
    cursor: not-allowed;
  }
}

::slotted(input),
::slotted(select),
::slotted(button) {
  height: var(--grey-box-height);
}
